import React from 'react';

import {
  useTheme,
  Grid,
  Box,
  Paper,
  Tooltip,
  Typography,
  Popover,
  Button,
  Link,
} from '@gogame/components';
import { useScreenMessage } from '@gogame/screens';

export default () => {
  const theme = useTheme();
  const {
    showWarningMessage,
    showSuccessMessage,
    showInfoMessage,
    showErrorMessage,
    showMessage,
  } = useScreenMessage();

  /* eslint-disable no-useless-escape */
  let data = JSON.stringify(theme.palette, null, 2);
  data = data.replaceAll(
    /rgba\([\d\.]+, [\d\.]+, [\d\.]+, [\d\.]+\)/gm,
    `<div style="display: inline-block; width: 12px; height: 12px; background: $&; margin-left: 8px;  margin-right: 8px;"></div> $&`
  );
  data = data.replaceAll(
    /rgb\([\d\.]+, [\d\.]+, [\d\.]+\)/gm,
    `<div style="display: inline-block; width: 12px; height: 12px; background: $&; margin-left: 8px;  margin-right: 8px;"></div> $&`
  );
  data = data.replaceAll(
    /\#[\w]{3,6}/gm,
    `<div style="display: inline-block; width: 12px; height: 12px; background: $&; margin-left: 8px;  margin-right: 8px;"></div> $&`
  );

  const handleShowToasts = () => {
    showErrorMessage('Error text', {
      ttl: 1000000,
      closable: true,
    });
    showSuccessMessage('Success text', {
      ttl: 1000000,
      closable: true,
    });
    showWarningMessage('Warning text', {
      ttl: 1000000,
      closable: true,
    });
    showInfoMessage('Info text', {
      ttl: 1000000,
      closable: true,
    });
    showMessage('Default text', {
      ttl: 1000000,
      closable: true,
    });
    showMessage(<Link>Default text with link</Link>, {
      ttl: 1000000,
      closable: true,
    });
  };

  return (
    <Grid container direction={'column'} spacing={3}>
      <Grid item>
        <Paper sx={{ padding: 3 }} spacing={3}>
          Paper text without Typography
          <Tooltip title={'Tooltip title'} wrapper>
            <Typography>Paper Typography Content with Tooltip</Typography>
          </Tooltip>
          <Popover
            hover
            anchor={
              <Typography>Paper Typography Content with Popover</Typography>
            }
          >
            <Box sx={{ padding: 1 }}>
              <Typography>Popover content</Typography>
            </Box>
          </Popover>
          <Button add variant={'outlined'}>
            add outlined
          </Button>
          <Button add variant={'filled'}>
            add filled
          </Button>
          <Button add>add default</Button>
          <Button variant={'outlined'} onClick={handleShowToasts}>
            Show toast warning
          </Button>
        </Paper>
      </Grid>
      <Grid
        item
        style={{
          marginTop: '16px',
          background: 'white',
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize,
        }}
      >
        <pre dangerouslySetInnerHTML={{ __html: data }} />
      </Grid>
    </Grid>
  );
};
